<mat-toolbar>
    <div class="md-toolbar-tools">
      <h1 mat-dialog-title>Faturar Contrato {{contrato.contratoId}}</h1>
      <span flex></span>
      <div class="posicionar-direita">
        <button (click)="restaurarDialog()" class="botao-header" [hidden]="!maximizado" matTooltip="Minimizar">
          <mat-icon>fullscreen_exit</mat-icon>
        </button>
        <button (click)="maximizarDialog()" class="botao-header" [hidden]="maximizado" matTooltip="Expandir">
          <mat-icon>fullscreen</mat-icon>
        </button>
        <button (click)="fecharDialog()" class="botao-header" matTooltip="Fechar">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </mat-toolbar>
  <div mat-dialog-actions>
  
  </div>
  <mat-dialog-content>
    <div class="md-dialog-content">
        <form [formGroup]="configuracoesFatura">
            <mat-vertical-stepper [linear]="true" #stepper formArrayName="formArray" (selectionChange)="onStepChange($event)">

                <mat-step formGroupName="0" [stepControl]="formArray.get([0])">
                    
                    <ng-template matStepLabel>Em qual empresa você deseja Faturar?</ng-template>
                <hr>
                <div class="row">
                    <mat-form-field class="col-md-6 col-xs-12 form-group">
                      <mat-label>Empresa</mat-label>
                      <mat-select formControlName="empresaId">
                        <mat-option *ngFor="let empresa of empresas" [value]="empresa.empresaId">
                          {{empresa.nomeFantasia}} - CNPJ {{empresa.cnpj}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                <hr>
                    <div class="row">
                        <div class="col-md-6"></div>
                        <div class="col-md-6"><button matStepperNext mat-raised-button color="primary">Próximo</button></div>
                      
                      
                    </div>

                </mat-step>
                <mat-step formGroupName="1" [stepControl]="formArray.get([1])" >
                    
                    <ng-template matStepLabel>Para quais itens você deseja gerar essa(s) Fatura(s)?</ng-template>
                <hr>
                <div class="row">
                    <div class="col-md-12">
                        <app-table fixed
                        [dataSource]="dataSource" 
                        [columns]="columns"
                        [enableSelection]="true"
                        [enablePagination]="false"
                        (selectionChange)="onSelectionChange($event)"> 
                    </app-table>
                    </div>
                  </div>
                  <mat-card appearance="outlined" class="" *ngIf="contrato.descontosAplicadosGlobalmente>0 && contrato.contratoItens.length>configuracoesFatura.get('formArray').get([1]).get('itens')?.value?.length && configuracoesFatura.get('formArray').get([1]).get('itens')?.value?.length>0">⚠️ Atenção! Esse contrato possui Descontos Globais aplicados (R$ {{contrato.descontosAplicadosGlobalmente}}). Ao escolher gerar a fatura apenas para alguns itens, esse desconto será dividido por igual pela quantidade de itens e aplicado ao novo valor da parcela</mat-card>
                <hr>
                    <div class="row">
                        <div class="col-md-6"><button matStepperPrevious mat-raised-button>Anterior</button></div>
                        <div class="col-md-6"><button matStepperNext mat-raised-button color="primary" [disabled]="!isItemSelected()" >Próximo</button></div>
                      
                      
                    </div>

                </mat-step>
                <mat-step formGroupName="2" [stepControl]="formArray.get([2])">
                    <ng-template matStepLabel>De qual período você deseja gerar a Fatura?</ng-template>
                    <hr>
                    <div class="row form-group">
                       
                        <mat-radio-group aria-label="Select an option" formControlName="quaisParcelasFaturar" required>
                          <div class="col-md-6"> <mat-radio-button value="todas">Gerar a(s) Fatura(s) de toda a vigência do Contrato</mat-radio-button></div>
                                <div class="col-md-6"><mat-radio-button value="algumas">Gerar apenas a(s) Fatura(s) com vencimento
                                em um determinado período</mat-radio-button></div>
                        </mat-radio-group>
                        

                    </div>
                    <div class="row" *ngIf="configuracoesFatura.get('formArray').get([2]).get('quaisParcelasFaturar').value =='algumas'">
                      <div class="col-md-6"></div>
                      <div class="col-md-3">
                          <mat-form-field>
                            <mat-label>Data da Início</mat-label>
                            <input matInput [matDatepicker]="picker1" formControlName="dataInicio"
                              (click)="picker1.open()">
                            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                            <mat-datepicker #picker1></mat-datepicker>
                          </mat-form-field>
                        </div>
                        <div class="col-md-3">
                          <mat-form-field>
                            <mat-label>Data da Fim</mat-label>
                            <input matInput [matDatepicker]="picker2" formControlName="dataFim"
                              (click)="picker2.open()">
                            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                            <mat-datepicker #picker2></mat-datepicker>
                          </mat-form-field>
                        </div>
                      </div>
                    <hr>
                    <div class="row">
                      <div class="col-md-6"><button matStepperPrevious mat-raised-button>Anterior</button></div>
                        <div class="col-md-6"><button matStepperNext mat-raised-button color="primary" [disabled]="configuracoesFatura.get('formArray').get([2]).invalid">Próximo</button></div>
                    </div>
                  
                </mat-step>
                <mat-step formGroupName="3" [stepControl]="formArray.get([3])">

                  <ng-template matStepLabel>Valores e Data de Vencimento</ng-template>
                  <div class="row">
                    <div class="col-md-12 col-sm-12 col-xs-12">
                        <app-calcula-parcelas fixed
                        [valorTotal]="somaTodasParcelasLiquidasDoContrato"
                        [tipoPagamento] = "contrato.metodoPagamento"
                        [intervaloParcelas]="intervaloEmDiasEntreAsParcelas"
                        [parcelasIniciais]="parcelasContrato"
                        [parcelaIdNome] = "'parcelaId'"
                        [panelOpenState] = "false"
                        (parcelasFinaisChange)="onParcelasFinaisChange($event)">
                        </app-calcula-parcelas>
                    </div>
                    </div>
                  <div class="row">
                    <div class="col-md-6"><button matStepperPrevious mat-raised-button>Anterior</button></div>
                      <div class="col-md-6"><button matStepperNext mat-raised-button color="primary" [disabled]="(!parcelasValidas) || configuracoesFatura.get('formArray').get([3]).invalid">Próximo</button></div>
                  </div>
                </mat-step>
                <mat-step formGroupName="4" [stepControl]="formArray.get([4])">
                    
                    <ng-template matStepLabel>Como será o faturamento desse contrato?</ng-template>

                <div class="row form-group">
                  
                    <mat-card appearance="outlined" class="=">Ciclo de Faturamento desse Contrato: <b>{{getTipoFaturamentoTexto() | uppercase}}</b></mat-card>
                  
                    <mat-radio-group aria-label="Selecione uma opção" formControlName="comoFaturar" required>
                      <div class="col-md-6">
                        <mat-radio-button value="separado">
                          Para cada ciclo de faturamento gerar sua própria Fatura, Nota Fiscal e Boleto.
                          <mat-icon matTooltip="Esta opção cria uma fatura separada para cada ciclo de faturamento do contrato. Exemplo: Se o Ciclo de Faturamento desse Contrato for Mensal, com vigência de 12 meses, serão geradas 12 faturas distintas, uma para cada ciclo de faturamento.">info</mat-icon>
                            
                          </mat-radio-button>
                          
                        </div>
                            <div class="col-md-6">
                              <mat-radio-button value="junto"> 
                                Gerar uma única Fatura e Nota Fiscal para o contrato inteiro, mas cada ciclo de faturamento terá seu próprio Boleto.
                              <mat-icon matTooltip="Esta opção gera uma única fatura que agrega todas as parcelas do contrato. Exemplo: Se Ciclo de Faturamento desse Contrato for Mensal, com vigência de 12 meses, será gerada uma única fatura com 12 parcelas dentro dela.">info</mat-icon>
                            </mat-radio-button>
                            </div>
                            </mat-radio-group>

                </div>
                <hr>
                    <div class="row">
                      <div class="col-md-6"><button matStepperPrevious mat-raised-button>Anterior</button></div>
                        <div class="col-md-6"><button matStepperNext mat-raised-button color="primary" >Próximo</button></div>
                      
                      
                    </div>

                </mat-step>
                <mat-step formGroupName="5" [stepControl]="formArray.get([5])">
                 <ng-template matStepLabel>Informações Financeiras</ng-template>
                  <hr>
                  <div class="row form-group">
                    <div class="row"><div class="col-md-12"> <p>Insira as informações necessárias para faturamento</p></div></div>
                    <br>
                   <div class="row">
                    <mat-form-field class="col-md-4 col-xs-12 form-group">
                      <mat-label>Centro de Custo</mat-label>
                      <mat-select formControlName="centroCustoId">
                        <mat-option *ngFor="let centroCusto of centroCustos" [value]="centroCusto.centroCustoId">
                          {{centroCusto.descricao}}
                        </mat-option>
                        <mat-option *ngIf="centroCustos?.length == 0" disabled>
                          ❌ Não existem Centro de Custos cadastrados para a empresa de faturamento selecionada. <a (click)="centroCusto()">Clique aqui</a> para visualizar todos os centros de custos disponíveis.  
                         </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field class="col-md-4 col-xs-12 form-group">
                      <mat-label>Categoria</mat-label>
                      <mat-select formControlName="grupoContaId">
                        <mat-option *ngFor="let grupoConta of grupoContas" [value]="grupoConta.grupoContaId">
                          {{grupoConta.descricao}}
                        </mat-option>
                        <mat-option *ngIf="grupoContas?.length == 0" disabled>
                          ❌ Não existem Categorias cadastradas para a empresa de faturamento selecionada. <a (click)="categoriasFinanceiras()">Clique aqui</a> para visualizar todos as categorias disponíveis.  
                         </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field class="col-md-4 col-xs-12 form-group">
                      <mat-label>Caixa (Fluxo de Caixa)</mat-label>
                      <mat-select formControlName="caixaId">
                        <mat-option *ngFor="let caixa of caixas" [value]="caixa.caixaId">
                          {{caixa.nome}}
                        </mat-option>
                        <mat-option *ngIf="caixas?.length == 0" disabled>
                          ❌ Não existem Caixas cadastrados para a empresa de faturamento selecionada. <a (click)="caixaFinanceiro()">Clique aqui</a> para visualizar todos os templates disponíveis.  
                         </mat-option>
                      </mat-select>
                    </mat-form-field>
                   </div>
                  </div>
                  <hr>
                  <div class="row">
                      <div class="col-md-6"><button matStepperPrevious mat-raised-button>Anterior</button></div>
                      <div class="col-md-6"><button matStepperNext mat-raised-button color="primary">Próximo</button></div>
                    
                    
                  </div>

              </mat-step>
              <mat-step *ngIf="integracaoSOC" formGroupName="6" [stepControl]="formArray.get([6])">
                 
                <ng-template matStepLabel>Integração com o SOC</ng-template>
                <hr>
                <div class="row form-group">
                  <mat-form-field class="col-md-6 col-xs-12 form-group">
                    <mat-label>Status Integração com o SOC</mat-label>
                    <mat-select formControlName="statusIntegracaoSOC">
                      <mat-option [value]="0">Desligada</mat-option>
                      <mat-option [value]="1">Ligada</mat-option>
                      <mat-option [value]="2">Processada</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <hr>
                <div class="row">
                    <div class="col-md-6"><button matStepperPrevious mat-raised-button>Anterior</button></div>
                    <div class="col-md-6"><button matStepperNext mat-raised-button color="primary">Próximo</button></div>
                  
                  
                </div>

            </mat-step>
          
              <mat-step>
                <ng-template matStepLabel>Confirmar</ng-template>
                O sistema criará as Faturas abaixo, com suas respectivas Parcelas. Deseja confirmar essa operação?
                <div class="row">
                  <mat-list class="faturas">
                    <!-- Itera sobre cada fatura com um índice sequencial -->
                    <div *ngFor="let fatura of faturas; let i = index">
                      <!-- Cabeçalho para cada fatura -->
                      <div mat-subheader>
                        Fatura #{{ i + 1 }} - Valor Total Líquido: {{ fatura.valorLiquido | currency }}
                      </div>
                  
                      <!-- Itera sobre cada parcela da fatura atual -->
                      <mat-list>
                        <mat-list-item *ngFor="let parcela of fatura.faturaParcelas; let y = index">
                          <mat-icon mat-list-icon>local_atm</mat-icon>
                          <div mat-line>Parcela #{{ y + 1 }}</div>
                          <div mat-line>Data de Vencimento: {{ parcela.dataVencimento | date }}</div>
                          <div mat-line>Valor da Parcela: {{ parcela.valorParcela | currency }}</div>
                        </mat-list-item>
                      </mat-list>
                  
                      <mat-divider></mat-divider>
                    </div>
                  </mat-list>
                </div>
                <hr>
                <div class="row">
                  <div class="col-md-6"><button matStepperPrevious mat-raised-button (click)="stepper.reset()">Voltar</button></div>
                  <div class="col-md-6"><button matStepperNext mat-raised-button color="primary" [disabled]="configuracoesFatura.invalid" (click)="salvarFaturas()">Criar Fatura(s)</button></div>
                </div>
              </mat-step>
 
       
              </mat-vertical-stepper>

        </form>
     
    </div>
      

  </mat-dialog-content>
  